import { useState } from "react";
import { BatteryLow, Battery, Zap, Frown, Meh, Smile } from "lucide-react";

const ENERGY_OPTIONS = [
  { value: 1, icon: BatteryLow, label: "Drained" },
  { value: 2, icon: Battery, label: "Okay" },
  { value: 3, icon: Zap, label: "Energized" },
];
const MOOD_OPTIONS = [
  { value: 1, icon: Frown, label: "Low" },
  { value: 2, icon: Meh, label: "Neutral" },
  { value: 3, icon: Smile, label: "Good" },
];
const TIME_OPTIONS = [15, 30, 45];

export const ReadinessCheckin = ({ onSubmit, submitting }) => {
  const [energy, setEnergy] = useState(null);
  const [mood, setMood] = useState(null);
  const [time, setTime] = useState(null);
  const canSubmit = !!energy && !!mood && !!time;

  return (
    <div className="glass-card rounded-3xl p-6" data-testid="readiness-checkin-card">
      <p className="text-sm font-medium text-kaizen-text mb-1">Quick check-in — about 15 seconds</p>
      <p className="text-xs text-kaizen-dim mb-5">This decides today's session. Nothing shows before this.</p>

      <p className="text-xs text-kaizen-dim uppercase tracking-widest mb-2">Energy</p>
      <div className="flex gap-2 mb-5">
        {ENERGY_OPTIONS.map(({ value, icon: Icon, label }) => (
          <button
            key={value}
            onClick={() => setEnergy(value)}
            data-testid={`energy-option-${value}`}
            className={`flex-1 flex flex-col items-center gap-1.5 py-3 rounded-2xl border transition-colors duration-300 ${
              energy === value ? "border-kaizen-violet bg-kaizen-violet/15 text-kaizen-violetSoft" : "border-white/10 text-kaizen-dim"
            }`}
          >
            <Icon size={20} />
            <span className="text-[11px]">{label}</span>
          </button>
        ))}
      </div>

      <p className="text-xs text-kaizen-dim uppercase tracking-widest mb-2">Mood</p>
      <div className="flex gap-2 mb-5">
        {MOOD_OPTIONS.map(({ value, icon: Icon, label }) => (
          <button
            key={value}
            onClick={() => setMood(value)}
            data-testid={`mood-option-${value}`}
            className={`flex-1 flex flex-col items-center gap-1.5 py-3 rounded-2xl border transition-colors duration-300 ${
              mood === value ? "border-kaizen-violet bg-kaizen-violet/15 text-kaizen-violetSoft" : "border-white/10 text-kaizen-dim"
            }`}
          >
            <Icon size={20} />
            <span className="text-[11px]">{label}</span>
          </button>
        ))}
      </div>

      <p className="text-xs text-kaizen-dim uppercase tracking-widest mb-2">Time today</p>
      <div className="flex gap-2 mb-6">
        {TIME_OPTIONS.map((t) => (
          <button
            key={t}
            onClick={() => setTime(t)}
            data-testid={`time-option-${t}`}
            className={`flex-1 py-3 rounded-2xl border text-sm transition-colors duration-300 ${
              time === t ? "border-kaizen-violet bg-kaizen-violet/15 text-kaizen-violetSoft" : "border-white/10 text-kaizen-dim"
            }`}
          >
            {t === 45 ? "45+ min" : `${t} min`}
          </button>
        ))}
      </div>

      <button
        onClick={() => onSubmit({ energy, mood, time_minutes: time })}
        disabled={!canSubmit || submitting}
        data-testid="submit-readiness-button"
        className="glow-cta w-full py-3.5 rounded-full bg-kaizen-violet text-[#140A24] font-semibold text-sm disabled:opacity-50 hover:scale-[1.01] transition-transform duration-300"
      >
        {submitting ? "Nova is thinking…" : "Check in"}
      </button>
    </div>
  );
};
